import importComponent, { render } from './helpers/bootstrap';
import { BREAKPOINT } from './constants';
import { antiForgeryAjax } from './helpers/xhr';
import * as maska from 'maska';

$(() => {
  antiForgeryAjax();
  maska.create('.masked');

  importComponent('BathroomRemodelingGuideForm', '.brg-form').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('KitchenRemodelingGuideForm', '.krg-form').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('IntuneForm', '.intune-form').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('PhoneSwap', '.yotrack-phone').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('IconSlider', '.icon-slider:not(.icon-slider--hero)').then(
    data => {
      if (!data) return;
      const { component, el } = data;

      new component(el);
    }
  );

  importComponent('IconSlider', '.icon-slider--hero').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el, {
      autoplay: true
    });
  });

  importComponent('DifmSlider', '.difm-slider').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('StatisticsSlider', '.statistics').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent(
    'ReviewsList',
    '.reviews-list:not(.reviews-list--flexible)'
  ).then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('ReviewsListFlexible', '.reviews-list--flexible').then(
    data => {
      if (!data) return;
      const { component, el } = data;

      new component(el);
    }
  );

  importComponent('FeatureSlider', '.feature-slider').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('InspirationBoard', '.inspiration-board').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('ReadMore', '.feature-slider').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(
      el,
      $target =>
        new component($target, {
          textSelector: '.feature-slider__content',
          maxLines: 8
        })
    );
  });
  importComponent('ReadMore', '.team-member').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(
      el,
      $target =>
        new component($target, {
          textSelector: '.team-member__biography',
          maxLines: 4,
          responsive: [
            {
              breakpoint: BREAKPOINT.tablet,
              config: {
                maxLines: 5
              }
            }
          ]
        })
    );
  });

  importComponent('ReadMore', '.who-we-are').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(
      el,
      $target =>
        new component($target, {
          textSelector: '.who-we-are__content',
          maxLines: false,
          responsive: [
            {
              breakpoint: BREAKPOINT.desktop,
              config: {
                maxLines: 8
              }
            },
            {
              breakpoint: BREAKPOINT.tablet,
              config: {
                maxLines: 12
              }
            }
          ]
        })
    );
  });

  importComponent('HeaderBrandSwitcher', '.js-header-brand-switcher').then(
    data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => new component($target));
    }
  );

  importComponent('ZipLocation', '.js-zip-location').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('FormOffer', '.js-form-offer').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('tailored_living/FormOffer', '.js-form-offer-tl').then(
    data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => new component($target));
    }
  );

  importComponent('ContentSlider', '.content-slider').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(el, $target => {
      new component($target);
    });
  });

  importComponent('BeforeAfter', '.before-after').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(el, $target => {
      new component($target);
    });
  });

  importComponent('FeaturedReviewsSlider', '.featured-reviews').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(el, $target => {
      new component($target);
    });
  });

  importComponent('ReviewsSlider', '.reviews-slider').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(el, $target => {
      new component($target);
    });
  });

  importComponent('SliderHero', '.js-slider-hero').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(el, $target => new component($target));
  });
  importComponent('ProductsGallery', '.prod-gallery').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });
  importComponent('Modal', '.js-modal').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });
  importComponent('FeaturedCompare', '.featured-compare').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });
  importComponent('ProjectsGalleryListing', '.proj-gallery__listing').then(
    data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => new component($target));
    }
  );
  importComponent('FileField', '.js-file-field').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(el, $target => new component($target));
  });

  importComponent('ReadMore', '.local-info__section').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(
      el,
      $target =>
        new component($target, {
          textSelector: '.local-info__section-content',
          maxLines: 3,
          responsive: [
            {
              breakpoint: BREAKPOINT.tablet,
              config: {
                maxLines: 5
              }
            }
          ]
        })
    );
  });

  importComponent('EpiFormCustomChoiceField', '.FormChoice').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('CustomFormSelection', '.FormSelection').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(
      el,
      $target =>
        new component($target, {
          minimumResultsForSearch: -1
        })
    );
  });

  importComponent('TrimText', '.related-post__title-link').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(
      el,
      $target =>
        new component($target, {
          charCount: 35
        })
    );
  });
  importComponent('TrimText', '.related-post__teaser').then(data => {
    if (!data) return;
    const { component, el } = data;
    render(
      el,
      $target =>
        new component($target, {
          lines: 3,
          charCount: 115,
          responsive: [
            {
              breakpoint: BREAKPOINT.desktop,
              config: {
                lines: 2
              }
            },
            {
              breakpoint: BREAKPOINT.tablet,
              config: {
                lines: 3
              }
            }
          ]
        })
    );
  });

  importComponent('Locations', '.locations').then(data => {
    if (!data) return;
    const { component, el } = data;
    new component(el);
  });

  importComponent('BlogListing', '.blog-listing').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('GenericHero', '.generic-hero').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('TabModule', '.tab-module').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
    new component(el);
  });

  importComponent('SwatchGallery', '.swatch-gallery').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('ServicesSlider', '.services').then(data => {
    if (!data) return;
    const { component, el } = data;

    new component(el);
  });

  importComponent('AirDuctCalculator', '.air-duct-calculator').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('CookieForm', '.js-form-privacy').then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => new component($target));
  });

  importComponent('FormValidate', '.js-validate')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => new component($target));
    });

  // Check object-fit
  if ('objectFit' in document.documentElement.style) {
    $('body').addClass('supports-object-fit');
  }
});

// Hot module replacement
if (__DEV__) {
  if (module.hot) module.hot.accept();
}

import { FooterNav } from '../js/components/FooterNav';
import { PrimaryNav } from '../js/components/PrimaryNav';
import { Dropdown } from '../js/components/Dropdown';
import { headerSearch } from '../js/components/Header';
import { JumpLink } from '../js/components/JumpLink';
import { Accordion } from '../js/components/Accordion';
import { TwoColContent } from '../js/components/TwoColContent';
import { LazyLoad } from './components/LazyLoad';

if (document.querySelectorAll('.footer-nav').length > 0) {
  FooterNav();
}

if (document.querySelectorAll('.primary-nav').length > 0) {
  PrimaryNav();
}

if (
  document.querySelectorAll('.language-selector').length > 0 ||
  document.querySelectorAll('.category-select').length > 0
) {
  Dropdown();
}

if (document.querySelectorAll('.header').length > 0) {
  headerSearch();
}

if (document.querySelectorAll('.js-jumplink').length > 0) {
  JumpLink();
}

if (document.querySelectorAll('.accordion').length > 0) {
  Accordion();
}

if (document.querySelectorAll('.twocol-content').length > 0) {
  TwoColContent();
}

if (document.querySelectorAll('[data-src]').length > 0) {
  LazyLoad();
}



// WEBPACK FOOTER //
// ./src/cc/js/main.js